import { Text, Box } from '@chakra-ui/react'

export default function TaskBreadcrumb({ children }: any) {
  return (
    <Box pl={4}>
      <Text fontWeight={'semibold'} fontSize={'xs'} color="gray.500">
        ({children})
      </Text>
    </Box>
  )
}
